import { pick } from 'lodash';

export const name = 'Паўтарыце, што сказалі';
export const nameShort = 'Паўтарыце, што сказалі';
export const bgInTable = '#1bddef';

export const fields = [
  {
    name: 'correctAnswers',
    default: [],
    label: 'Правільныя адказы',
    component: 'ListNewValues',
  },
  {
    name: 'afterTaskExplanation',
    default: '',
    label: 'Тлумачэнне задання',
    component: 'Textarea',
  },
  {
    name: 'textContent',
    default: '',
    label: 'Змест задання',
    component: 'Input',
  },
  {
    name: 'audio',
    default: '',
    label: 'Аўдыёзапісы',
    component: 'AudioInput',
  },
];

export const dataToSend = form => {
  return {
    additionalData: {
      afterTaskExplanation: form.afterTaskExplanation,
      textContent: form.textContent,
    },
    type: 'repeat_sentence',
    name: form.name,
    tip: form.tip,
    status: form.status,
    correctAnswers: form.correctAnswers,
    audio: form.audio,
  };
};

export const parseData = data => {
  const dataFast = pick(data, ['name', 'status', 'audio', 'correctAnswers']);
  const { afterTaskExplanation, textContent } = data.additionalData;
  return {
    ...dataFast,
    afterTaskExplanation,
    textContent,
  };
};
